module.exports = __webpack_public_path__ + "static/doubled-cover-bg-8f0553bf827d7a870ed3ce56f8a11f63.jpg";